import { api } from './client'
import type { Workflow } from '@/types/dashboard'

export function detectDomain(domain: string) {
  return api<{ success: boolean; patterns?: Workflow[] }>('/api/workflows/detect', {
    method: 'POST',
    body: JSON.stringify({ domain })
  })
}

export async function detectAllDomains(fallbackDomains: string[] = []) {
  const recent = await api<{ activities?: { url: string }[] }>('/api/activities/recent?limit=80')
  const fromActivity = [
    ...new Set(
      (recent.activities || [])
        .map((a) => {
          try {
            return new URL(a.url).hostname
          } catch {
            return null
          }
        })
        .filter(Boolean) as string[]
    )
  ]
  const domains = fromActivity.length ? fromActivity : fallbackDomains
  let total = 0
  for (const domain of domains) {
    const res = await detectDomain(domain)
    total += res.patterns?.length || 0
  }
  return { domains: domains.length, patterns: total }
}
